import { createFileRoute } from "@tanstack/react-router";
import { OrganizationsListPage } from "../../../components/organizations/OrganizationsListPage";
import { requireAuth, requireModuleAccess, MODULE_WORKSPACE } from "../../../lib/auth/route-protection";

export const Route = createFileRoute("/workspace/organizations/")({
  beforeLoad: () => {
    requireAuth()();
    requireModuleAccess(MODULE_WORKSPACE)();
  },
  component: OrganizationsListPage,
});
